import React from "react";
import ProductLocation from "../ProductLocation";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import "./index.css";
import VideoPlayer from "../VideoPlayer";
import { VIDEO_UPLOAD, YOUTUBE_URL } from "../../../../Constants/types";
import ProductBanner from "../ProductBanner";

export default function ProductThumbnail({ productData }) {
  const { media } = productData;
  const location = useLocation();

  const formatProductCaption = () => {
    const { brand: brandId } = location.state;
    const { customNameByBrand, caption } = productData;

    if (customNameByBrand && customNameByBrand[brandId])
      return customNameByBrand[brandId];
    return caption;
  };

  const isVideo =
    (media && media[0].mediaType === YOUTUBE_URL) ||
    (media && media[0].mediaType === VIDEO_UPLOAD);
  const url = media && media[0].mediaUrl;

  return (
    <article className="product-thumbnail">
      <ProductBanner
        isEcoPackage={productData.isEcoPackage}
        product={productData}
      />
      {isVideo ? (
        <VideoPlayer
          src={url}
          isUploadedVideo={media[0].mediaType === VIDEO_UPLOAD}
          className="product__video-player"
        />
      ) : (
        <div
          className="product-thumbnail__img-container"
          style={{ backgroundImage: `url(${url})` || "none" }}
        />
      )}
      <h3 className="product-thumbnail__caption">
        {formatProductCaption(productData.caption)}
      </h3>
      {productData.address && <ProductLocation address={productData.address} />}
      <p className="product-thumbnail__description">
        {productData.description}
      </p>
    </article>
  );
}



// WEBPACK FOOTER //
// ./src/components/Package/components/ProductThumbnail/index.js